"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var isAndroidWebhookMethodAvailable = function isAndroidWebhookMethodAvailable(webhookMethodName) {
  return window.Android && typeof window.Android[webhookMethodName] === 'function';
};

var isIOSWebhookMethodAvailable = function isIOSWebhookMethodAvailable(webhookMethodName) {
  return window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[webhookMethodName] && typeof window.webkit.messageHandlers[webhookMethodName].postMessage === 'function';
};

var isWebhookDataAnObject = function isWebhookDataAnObject(webhookData) {
  return (0, _typeof2["default"])(webhookData) === 'object' && webhookData instanceof Array === false;
};

var triggerAndroidWebhookMethod = function triggerAndroidWebhookMethod(webhookMethodName, webhookData) {
  if (webhookData) {
    var formattedWebhookData = isWebhookDataAnObject(webhookData) ? JSON.stringify(webhookData) : webhookData;
    window.Android[webhookMethodName](formattedWebhookData);
  } else {
    window.Android[webhookMethodName]();
  }
};

var triggerIOSWebhookMethod = function triggerIOSWebhookMethod(webhookMethodName, webhookData) {
  if (webhookData) {
    window.webkit.messageHandlers[webhookMethodName].postMessage(webhookData);
  } else {
    window.webkit.messageHandlers[webhookMethodName].postMessage();
  }
};

function appWebhook(webhookMethodName, webhookData) {
  if (isAndroidWebhookMethodAvailable(webhookMethodName)) {
    triggerAndroidWebhookMethod(webhookMethodName, webhookData);
    return true;
  }

  if (isIOSWebhookMethodAvailable(webhookMethodName)) {
    triggerIOSWebhookMethod(webhookMethodName, webhookData);
    return true;
  }

  return false;
}

var _default = appWebhook;
exports["default"] = _default;